import React from 'react'
import { RegistrationCheck } from '../components/registration-check/RegistrationCheck'
import { RegistrationCheckProvider } from '../providers/registration-check-provider'
import { PageTitleComponent } from '../components/PageTitle'
import { PageTitle } from '../constants/messageConstants'

const Check = () => {
    return (
        <RegistrationCheckProvider>
            <PageTitleComponent pageTitle={PageTitle.REGISTRATION_CHECK} />
            <RegistrationCheck />
        </RegistrationCheckProvider>
    )
}

export default Check
